"use client";

import { useEffect, useMemo, useRef } from 'react';
import styles from './_hcp-page-footnote.module.scss';

export default function HcpPageFootnote({lessPadding = false, maxWidth = undefined, fullWidth = false, children}) {
  const containerRef = useRef(null);
  const containerClass = useMemo(() => {
    let className = `${styles.container} hcp-page-footnote`;

    if (lessPadding) {
      className = `${className} ${styles.less_padding}`;
    }

    if (fullWidth) {
      className = `${className} ${styles.full_width}`;
    }

    return className;
  }, [lessPadding, fullWidth]);

  useEffect(() => {
    maxWidth !== undefined && containerRef.current?.style.setProperty('--max-width', maxWidth);
  }, [maxWidth]);
  return (
    <section className={containerClass} ref={containerRef}>
      <div className="container--small">
        <div className={styles.constrain}>
          {children}
        </div>
      </div>
    </section>
  );
}